import { FORTA_BLUE } from '../../utils/colors';

import type { IconProps } from './types';

const TrashIcon = (props: IconProps) => {
  const { color = FORTA_BLUE.primary, width = 24, height = 25 } = props;

  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6.28125H5H21"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 6.28125V20.2812C19 20.8117 18.7893 21.3204 18.4142 21.6955C18.0391 22.0705 17.5304 22.2812 17 22.2812H7C6.46957 22.2812 5.96086 22.0705 5.58579 21.6955C5.21071 21.3204 5 20.8117 5 20.2812V6.28125M8 6.28125V4.28125C8 3.75082 8.21071 3.24211 8.58579 2.86704C8.96086 2.49196 9.46957 2.28125 10 2.28125H14C14.5304 2.28125 15.0391 2.49196 15.4142 2.86704C15.7893 3.24211 16 3.75082 16 4.28125V6.28125"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11.2812V17.2812"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 11.2812V17.2812"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TrashIcon;
